import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import MyDayPlaceholderCard from './my_day_placeholder_card';

const MyDayPlaceholderSection = ({ title }) => {
  return (
    <>
      <Grid container>
        <Grid item xs={8}>
          <h2
            style={{
              margin: '23px 23px 5px',
              color: 'var(--app-primary-font-color)',
            }}>
            {title}
          </h2>
        </Grid>
      </Grid>
      <div style={{ overflowX: 'auto', display: 'flex' }}>
        <div style={{ flexShrink: 0 }}>
          <MyDayPlaceholderCard />
        </div>
      </div>
    </>
  );
};

MyDayPlaceholderSection.propTypes = {
  title: PropTypes.string.isRequired,
};

export default MyDayPlaceholderSection;
